import { observer } from "mobx-react";
import { GrantLetterProgramModel, OptionGrantLetterForm } from "./optionGrantLetterDomain";
import { Box, VBox } from "@/components-v2/Box";
import { Alert } from "@/components-v2/Alert";
import { IconButton } from "@/components-v2/Button";
import { MCheckboxGroup } from "@/components-v2/Checkbox";
import { DropdownMenu } from "@/components-v2/Dropdown";
import { useTranslation } from "@/stores/RootStoreContext";

export const OptionGrantLetterView = observer(function OptionGrantLetterView({
  form,
}: {
  form: OptionGrantLetterForm;
}) {
  const { t } = useTranslation();

  if (form.candidates.length === 0) {
    return <Alert type={"info"} message={t("decisions.optionGrantLetter.no-grants")} />;
  }

  return (
    <VBox gap={"lg"}>
      <div>{t("decisionType.optionGrantLetter.text")}</div>
      {form.programs.map((program) => (
        <ProgramSection key={program.planId} form={form} program={program} />
      ))}
      {form.availablePrograms.length > 0 && (
        <Box>
          <DropdownMenu
            button={{
              type: "link",
              label: t("decisions.optionGrantLetter.add-program"),
              icon: "plus",
              disabled: form.isProjectLocked,
            }}
            items={form.availablePrograms.map((choice) => ({
              type: "item",
              label: choice.programName,
              onSelect: () => form.addProgram(choice.planId),
            }))}
          />
        </Box>
      )}
      {form.error && <Alert type={"error"} message={t(form.error)} />}
    </VBox>
  );
});

const ProgramSection = observer(function ProgramSection({
  form,
  program,
}: {
  form: OptionGrantLetterForm;
  program: GrantLetterProgramModel;
}) {
  const { t } = useTranslation();

  return (
    <VBox gap={"sm"} border rounded padding={"md"}>
      <Box justifyContent={"space-between"} alignItems={"center"}>
        <strong>{program.programName}</strong>
        {!form.isProjectLocked && (
          <IconButton
            icon={"trash"}
            tooltip={t("decisions.optionGrantLetter.remove-program")}
            onClick={() => form.removeProgram(program.planId)}
          />
        )}
      </Box>
      <MCheckboxGroup model={program.holders} disabled={form.isProjectLocked} />
    </VBox>
  );
});
